import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { setContentBlock } from '../../slices/content-block-slice';
import Modal from 'react-modal';
import { H4, P3 } from '../../styles/FontStyles';
import { Flexed, TermsWrapper } from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';
import { lightTheme } from '../../styles/GlobalStyles';
import { Button } from '../common';

export const ContentBlockModal = ({
  title,
  subtitle,
  content,
  modal,
  setModal,
  setCheckbox
}: {
  title: string;
  subtitle: string;
  content: string;
  modal: boolean;
  setModal: (modal: boolean) => void;
  setCheckbox: (checkbox: boolean) => void;
}) => {
  const dispatch = useAppDispatch();

  const closeModal = () => {
    setModal(false);
    dispatch(setContentBlock(null));
  };

  return (
    <Modal
      isOpen={modal}
      onRequestClose={() => setModal(!modal)}
      contentLabel='Terms Conditions'
      className={'termsModal'}
      overlayClassName='myoverlay'
      closeTimeoutMS={500}
      ariaHideApp={false}>
      <H4 center mb='10'>
        {title}
      </H4>
      <P3 center mb='24'>
        {subtitle}
      </P3>
      <TermsWrapper>
        <div
          style={{
            color: colors.neutral900
          }}
          dangerouslySetInnerHTML={{
            __html: content
          }}
        />
      </TermsWrapper>

      <Flexed gap='15px' gapSM='10px' rowReverseSM justifyCenter>
        <Button
          textColor={lightTheme.colors.primary900}
          w='200px'
          textButton
          onClick={closeModal}>
          Cancel
        </Button>

        <Button
          w='200px'
          onClick={() => {
            closeModal();
            setCheckbox(true);
          }}>
          Agree
        </Button>
      </Flexed>
    </Modal>
  );
};
